/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as QueueRouteImport } from './routes/queue'
import { Route as ManualRouteImport } from './routes/manual'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppsIdRouteImport } from './routes/apps.$id'
import { Route as AppsIdIntakeRouteImport } from './routes/apps.$id.intake'
import { Route as AppsIdDecisionRouteImport } from './routes/apps.$id.decision'
import { Route as AppsIdCoordinationRouteImport } from './routes/apps.$id.coordination'
import { Route as AppsIdAnalysisRouteImport } from './routes/apps.$id.analysis'

const QueueRoute = QueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => rootRouteImport,
} as any)
const ManualRoute = ManualRouteImport.update({
  id: '/manual',
  path: '/manual',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsIdRoute = AppsIdRouteImport.update({
  id: '/apps/$id',
  path: '/apps/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AppsIdIntakeRoute = AppsIdIntakeRouteImport.update({
  id: '/intake',
  path: '/intake',
  getParentRoute: () => AppsIdRoute,
} as any)
const AppsIdDecisionRoute = AppsIdDecisionRouteImport.update({
  id: '/decision',
  path: '/decision',
  getParentRoute: () => AppsIdRoute,
} as any)
const AppsIdCoordinationRoute = AppsIdCoordinationRouteImport.update({
  id: '/coordination',
  path: '/coordination',
  getParentRoute: () => AppsIdRoute,
} as any)
const AppsIdAnalysisRoute = AppsIdAnalysisRouteImport.update({
  id: '/analysis',
  path: '/analysis',
  getParentRoute: () => AppsIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/manual': typeof ManualRoute
  '/queue': typeof QueueRoute
  '/apps/$id': typeof AppsIdRouteWithChildren
  '/apps/$id/analysis': typeof AppsIdAnalysisRoute
  '/apps/$id/coordination': typeof AppsIdCoordinationRoute
  '/apps/$id/decision': typeof AppsIdDecisionRoute
  '/apps/$id/intake': typeof AppsIdIntakeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/manual': typeof ManualRoute
  '/queue': typeof QueueRoute
  '/apps/$id': typeof AppsIdRouteWithChildren
  '/apps/$id/analysis': typeof AppsIdAnalysisRoute
  '/apps/$id/coordination': typeof AppsIdCoordinationRoute
  '/apps/$id/decision': typeof AppsIdDecisionRoute
  '/apps/$id/intake': typeof AppsIdIntakeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/manual': typeof ManualRoute
  '/queue': typeof QueueRoute
  '/apps/$id': typeof AppsIdRouteWithChildren
  '/apps/$id/analysis': typeof AppsIdAnalysisRoute
  '/apps/$id/coordination': typeof AppsIdCoordinationRoute
  '/apps/$id/decision': typeof AppsIdDecisionRoute
  '/apps/$id/intake': typeof AppsIdIntakeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/manual'
    | '/queue'
    | '/apps/$id'
    | '/apps/$id/analysis'
    | '/apps/$id/coordination'
    | '/apps/$id/decision'
    | '/apps/$id/intake'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/login'
    | '/manual'
    | '/queue'
    | '/apps/$id'
    | '/apps/$id/analysis'
    | '/apps/$id/coordination'
    | '/apps/$id/decision'
    | '/apps/$id/intake'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/login'
    | '/manual'
    | '/queue'
    | '/apps/$id'
    | '/apps/$id/analysis'
    | '/apps/$id/coordination'
    | '/apps/$id/decision'
    | '/apps/$id/intake'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  LoginRoute: typeof LoginRoute
  ManualRoute: typeof ManualRoute
  QueueRoute: typeof QueueRoute
  AppsIdRoute: typeof AppsIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/queue': {
      id: '/queue'
      path: '/queue'
      fullPath: '/queue'
      preLoaderRoute: typeof QueueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manual': {
      id: '/manual'
      path: '/manual'
      fullPath: '/manual'
      preLoaderRoute: typeof ManualRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/$id': {
      id: '/apps/$id'
      path: '/apps/$id'
      fullPath: '/apps/$id'
      preLoaderRoute: typeof AppsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/apps/$id/intake': {
      id: '/apps/$id/intake'
      path: '/intake'
      fullPath: '/apps/$id/intake'
      preLoaderRoute: typeof AppsIdIntakeRouteImport
      parentRoute: typeof AppsIdRoute
    }
    '/apps/$id/decision': {
      id: '/apps/$id/decision'
      path: '/decision'
      fullPath: '/apps/$id/decision'
      preLoaderRoute: typeof AppsIdDecisionRouteImport
      parentRoute: typeof AppsIdRoute
    }
    '/apps/$id/coordination': {
      id: '/apps/$id/coordination'
      path: '/coordination'
      fullPath: '/apps/$id/coordination'
      preLoaderRoute: typeof AppsIdCoordinationRouteImport
      parentRoute: typeof AppsIdRoute
    }
    '/apps/$id/analysis': {
      id: '/apps/$id/analysis'
      path: '/analysis'
      fullPath: '/apps/$id/analysis'
      preLoaderRoute: typeof AppsIdAnalysisRouteImport
      parentRoute: typeof AppsIdRoute
    }
  }
}

interface AppsIdRouteChildren {
  AppsIdAnalysisRoute: typeof AppsIdAnalysisRoute
  AppsIdCoordinationRoute: typeof AppsIdCoordinationRoute
  AppsIdDecisionRoute: typeof AppsIdDecisionRoute
  AppsIdIntakeRoute: typeof AppsIdIntakeRoute
}

const AppsIdRouteChildren: AppsIdRouteChildren = {
  AppsIdAnalysisRoute: AppsIdAnalysisRoute,
  AppsIdCoordinationRoute: AppsIdCoordinationRoute,
  AppsIdDecisionRoute: AppsIdDecisionRoute,
  AppsIdIntakeRoute: AppsIdIntakeRoute,
}

const AppsIdRouteWithChildren =
  AppsIdRoute._addFileChildren(AppsIdRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  LoginRoute: LoginRoute,
  ManualRoute: ManualRoute,
  QueueRoute: QueueRoute,
  AppsIdRoute: AppsIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
